import { AnimatedSprite } from "appworks/graphics/animation/animated-sprite";
import { ButtonElement } from "appworks/graphics/elements/button-element";
import { SmartShape } from "appworks/graphics/elements/smart-shape";
import { Layers } from "appworks/graphics/layers/layers";
import { Scene } from "appworks/graphics/layers/scene";
import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Text } from "appworks/graphics/pixi/text";
import { SoundNames } from "sounds-enum";

class GameLayers {
    public CelebrationContent: Layers & {
        scene: {
             fullhouse: Scene & {
                contents: {
                    CelebrationEggs?: Sprite
                    CelebrationFeathers?: Sprite
                    fullhouse?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        particles?: DualPosition
                    };
                    CelebrationEggs?: Sprite
                    CelebrationFeathers?: Sprite
                    fullhouse?: Text
                    chicken?: SpineContainer
                    value?: Text
                    label?: Text
                    slingo_spine?: SpineContainer
                    fox?: Sprite
                };
            };
             megawin: Scene & {
                contents: {
                    chicken?: SpineContainer
                    value?: Text
                    label?: Text
                    positions: {
                        [key: string]: DualPosition
                        particles?: DualPosition
                    };
                };
            };
             superwin: Scene & {
                contents: {
                    chicken?: SpineContainer
                    value?: Text
                    label?: Text
                    positions: {
                        [key: string]: DualPosition
                        particles?: DualPosition
                    };
                };
            };
             bigwin: Scene & {
                contents: {
                    chicken?: SpineContainer
                    value?: Text
                    label?: Text
                    positions: {
                        [key: string]: DualPosition
                        particles?: DualPosition
                    };
                };
            };
             win: Scene & {
                contents: {
                    chicken?: SpineContainer
                    value?: Text
                    label?: Text
                    positions: {
                        [key: string]: DualPosition
                        particles?: DualPosition
                    };
                };
            };
             slingo: Scene & {
                contents: {
                    slingo_spine?: SpineContainer
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             wilds_added: Scene & {
                contents: {
                    fox?: Sprite
                    value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_row_0_win: Scene & {
                contents: {
                    value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_row_1_win: Scene & {
                contents: {
                    value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_row_2_win: Scene & {
                contents: {
                    value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public CelebrationBackground: Layers & {
        scene: {
             fullhouse: Scene & {
                contents: {
                    cover?: SmartShape
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    cover?: SmartShape
                };
            };
             bigwin: Scene & {
                contents: {
                    cover?: SmartShape
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Menus: Layers & {
        scene: {
             preloader: Scene & {
                contents: {
                    preloader?: SpineContainer
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    preloader?: SpineContainer
                    cover?: SmartShape
                    sound_effects?: Text
                    background_music?: Text
                    deposit?: ButtonElement
                    ui_help?: ButtonElement
                    ui_play_controls?: ButtonElement
                    lobby?: ButtonElement
                    history?: ButtonElement
                    frame?: Sprite
                    arrow_back?: ButtonElement
                    arrow_forward?: ButtonElement
                    stake_0?: ButtonElement
                    stake_1?: ButtonElement
                    stake_2?: ButtonElement
                    stake_3?: ButtonElement
                    stake_4?: ButtonElement
                    stake_5?: ButtonElement
                    stake_6?: ButtonElement
                    stake_7?: ButtonElement
                    stake_8?: ButtonElement
                    stake_9?: ButtonElement
                    stake_10?: ButtonElement
                    stake_11?: ButtonElement
                    close?: ButtonElement
                    save?: ButtonElement
                    cancel?: ButtonElement
                    extra_spins_0?: Text
                    extra_spins_1?: Text
                    extra_spins_2?: Text
                    extra_spins_3?: Text
                    extra_spins_4?: Text
                    spin_price_0?: Text
                    spin_price_1?: Text
                    spin_price_2?: Text
                    spin_price_3?: Text
                    spin_price_4?: Text
                    total_stake_0?: Text
                    total_stake_1?: Text
                    total_stake_2?: Text
                    total_stake_3?: Text
                    total_stake_4?: Text
                    total_loss_0?: Text
                    total_loss_1?: Text
                    total_loss_2?: Text
                    total_loss_3?: Text
                    total_loss_4?: Text
                    title_play_controls_spins?: Text
                    title_play_controls_spin_price?: Text
                    title_play_controls_stake?: Text
                    title_play_controls_loss?: Text
                };
            };
             settings: Scene & {
                contents: {
                    cover?: SmartShape
                    sound_effects?: Text
                    background_music?: Text
                    deposit?: ButtonElement
                    ui_help?: ButtonElement
                    ui_play_controls?: ButtonElement
                    lobby?: ButtonElement
                    history?: ButtonElement
                    frame?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             stake: Scene & {
                contents: {
                    cover?: SmartShape
                    arrow_back?: ButtonElement
                    arrow_forward?: ButtonElement
                    stake_0?: ButtonElement
                    stake_1?: ButtonElement
                    stake_2?: ButtonElement
                    stake_3?: ButtonElement
                    stake_4?: ButtonElement
                    stake_5?: ButtonElement
                    stake_6?: ButtonElement
                    stake_7?: ButtonElement
                    stake_8?: ButtonElement
                    stake_9?: ButtonElement
                    stake_10?: ButtonElement
                    stake_11?: ButtonElement
                    frame?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             rules: Scene & {
                contents: {
                    close?: ButtonElement
                    cover?: SmartShape
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             play_controls: Scene & {
                contents: {
                    cover?: SmartShape
                    save?: ButtonElement
                    cancel?: ButtonElement
                    extra_spins_0?: Text
                    extra_spins_1?: Text
                    extra_spins_2?: Text
                    extra_spins_3?: Text
                    extra_spins_4?: Text
                    spin_price_0?: Text
                    spin_price_1?: Text
                    spin_price_2?: Text
                    spin_price_3?: Text
                    spin_price_4?: Text
                    total_stake_0?: Text
                    total_stake_1?: Text
                    total_stake_2?: Text
                    total_stake_3?: Text
                    total_stake_4?: Text
                    total_loss_0?: Text
                    total_loss_1?: Text
                    total_loss_2?: Text
                    total_loss_3?: Text
                    total_loss_4?: Text
                    frame?: Sprite
                    title_play_controls_spins?: Text
                    title_play_controls_spin_price?: Text
                    title_play_controls_stake?: Text
                    title_play_controls_loss?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public SuperSpinWheel: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    cta_bg?: Sprite
                    help?: ButtonElement
                    spin?: ButtonElement
                    wheel_portrait?: SpineContainer
                    wheel_landscape?: SpineContainer
                    cta?: Text
                    counter?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    cta_bg?: Sprite
                    help?: ButtonElement
                    spin?: ButtonElement
                    wheel_portrait?: SpineContainer
                    wheel_landscape?: SpineContainer
                    cta?: Text
                    counter?: Text
                };
            };
        };
    };
    public FlingBonusTransition: Layers & {
        scene: {
             pick_out: Scene & {
                contents: {
                    fox_intro?: SpineContainer
                    positions: {
                        [key: string]: DualPosition
                        fox_intro_end?: DualPosition
                        fox_intro_start?: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        fox_intro_end?: DualPosition
                        fox_intro_start?: DualPosition
                        fox_intro_grab?: DualPosition
                    };
                    fox_intro?: SpineContainer
                    grab_mask?: Sprite
                };
            };
             fling_in: Scene & {
                contents: {
                    grab_mask?: Sprite
                    fox_intro?: SpineContainer
                    positions: {
                        [key: string]: DualPosition
                        fox_intro_grab?: DualPosition
                        fox_intro_start?: DualPosition
                    };
                };
            };
        };
    };
    public EggPickPaytable: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    backing?: Sprite
                    prize_white?: Text
                    prize_silver?: Text
                    prize_gold?: Text
                    prize_diamond?: Text
                    prize_jackpot?: Text
                    label_jackpot?: Text
                };
            };
             paytable_0: Scene & {
                contents: {
                    backing?: Sprite
                    prize_white?: Text
                    prize_silver?: Text
                    prize_gold?: Text
                    prize_diamond?: Text
                    prize_jackpot?: Text
                    label_jackpot?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             paytable_1: Scene & {
                contents: {
                    backing?: Sprite
                    prize_white?: Text
                    prize_jackpot?: Text
                    label_jackpot?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             paytable_2: Scene & {
                contents: {
                    backing?: Sprite
                    prize_white?: Text
                    prize_silver?: Text
                    prize_jackpot?: Text
                    label_jackpot?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             paytable_3: Scene & {
                contents: {
                    backing?: Sprite
                    prize_silver?: Text
                    prize_gold?: Text
                    prize_jackpot?: Text
                    label_jackpot?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             paytable_4: Scene & {
                contents: {
                    backing?: Sprite
                    prize_gold?: Text
                    prize_diamond?: Text
                    prize_jackpot?: Text
                    label_jackpot?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             paytable_5: Scene & {
                contents: {
                    backing?: Sprite
                    prize_diamond?: Text
                    prize_jackpot?: Text
                    label_jackpot?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public BonusUI: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    win_backing?: Sprite
                    picks_backing?: Sprite
                    bonus_label?: Text
                    totalWinMeter_label?: Text
                    totalWinMeter_value?: Text
                    pickMeter_label?: Text
                    pickMeter_value?: Text
                    win_p?: Sprite
                    spins_p?: Sprite
                    win?: Sprite
                    spins?: Sprite
                    spins_remaining_label?: Text
                    spins_remaining_value?: Text
                    total_win_label?: Text
                    total_win_value?: Text
                };
            };
             eggpick: Scene & {
                contents: {
                    win_backing?: Sprite
                    picks_backing?: Sprite
                    bonus_label?: Text
                    totalWinMeter_label?: Text
                    totalWinMeter_value?: Text
                    pickMeter_label?: Text
                    pickMeter_value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             slotbonus: Scene & {
                contents: {
                    win_p?: Sprite
                    spins_p?: Sprite
                    win?: Sprite
                    spins?: Sprite
                    spins_remaining_label?: Text
                    spins_remaining_value?: Text
                    total_win_label?: Text
                    total_win_value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public EggPickBonus: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        pick_below?: DualPosition
                        pick_above?: DualPosition
                        egg_upper_1?: DualPosition
                        egg_upper_2?: DualPosition
                        egg_upper_3?: DualPosition
                        egg_upper_4?: DualPosition
                        egg_upper_5?: DualPosition
                        egg_lower_1?: DualPosition
                        egg_lower_2?: DualPosition
                        egg_lower_3?: DualPosition
                        egg_lower_4?: DualPosition
                        egg_lower_5?: DualPosition
                        egg_upper_6?: DualPosition
                        egg_lower_6?: DualPosition
                    };
                    pick1?: SpineContainer
                    pick2?: SpineContainer
                    pick3?: SpineContainer
                    pick4?: SpineContainer
                    pick5?: SpineContainer
                    perch_foreground_landscape?: Sprite
                    perch_background_landscape?: Sprite
                    perch_foreground_portrait?: Sprite
                    perch_background_portrait?: Sprite
                    prize_value?: Text
                    pick6?: SpineContainer
                };
            };
             single_tier: Scene & {
                contents: {
                    pick1?: SpineContainer
                    pick2?: SpineContainer
                    pick3?: SpineContainer
                    pick4?: SpineContainer
                    pick5?: SpineContainer
                    perch_foreground_landscape?: Sprite
                    perch_background_landscape?: Sprite
                    perch_foreground_portrait?: Sprite
                    perch_background_portrait?: Sprite
                    prize_value?: Text
                    positions: {
                        [key: string]: DualPosition
                        pick_below?: DualPosition
                        pick_above?: DualPosition
                        egg_upper_1?: DualPosition
                        egg_upper_2?: DualPosition
                        egg_upper_3?: DualPosition
                        egg_upper_4?: DualPosition
                        egg_upper_5?: DualPosition
                        egg_lower_1?: DualPosition
                        egg_lower_2?: DualPosition
                        egg_lower_3?: DualPosition
                        egg_lower_4?: DualPosition
                        egg_lower_5?: DualPosition
                    };
                };
            };
             three_tier: Scene & {
                contents: {
                    pick1?: SpineContainer
                    pick2?: SpineContainer
                    pick3?: SpineContainer
                    pick4?: SpineContainer
                    pick5?: SpineContainer
                    pick6?: SpineContainer
                    perch_foreground_landscape?: Sprite
                    perch_background_landscape?: Sprite
                    perch_foreground_portrait?: Sprite
                    perch_background_portrait?: Sprite
                    prize_value?: Text
                    positions: {
                        [key: string]: DualPosition
                        pick_below?: DualPosition
                        pick_above?: DualPosition
                        egg_upper_1?: DualPosition
                        egg_upper_2?: DualPosition
                        egg_upper_3?: DualPosition
                        egg_upper_4?: DualPosition
                        egg_upper_5?: DualPosition
                        egg_upper_6?: DualPosition
                        egg_lower_1?: DualPosition
                        egg_lower_2?: DualPosition
                        egg_lower_3?: DualPosition
                        egg_lower_4?: DualPosition
                        egg_lower_5?: DualPosition
                        egg_lower_6?: DualPosition
                    };
                };
            };
        };
    };
    public FlingBonusForeground: Layers & {
        scene: {
             bonus: Scene & {
                contents: {
                    marker?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    marker?: Sprite
                };
            };
        };
    };
    public FlingBonus: Layers & {
        scene: {
             bonus: Scene & {
                contents: {
                    launch?: ButtonElement
                    paytable_bg?: Sprite
                    launch_arrow?: Sprite
                    fox_fling?: SpineContainer
                    coop?: SpineContainer
                    faf_chicken_march?: SpineContainer
                    shadow?: Sprite
                    paytable_grand_value?: Text
                    paytable_mega_value?: Text
                    paytable_major_value?: Text
                    paytable_minor_value?: Text
                    paytable_mini_value?: Text
                    paytable_grand_label?: Text
                    paytable_mega_label?: Text
                    paytable_major_label?: Text
                    paytable_minor_label?: Text
                    paytable_mini_label?: Text
                    positions: {
                        [key: string]: DualPosition
                        chicken_march_end?: DualPosition
                        fox_start?: DualPosition
                        duck?: DualPosition
                        pig?: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        chicken_march_end?: DualPosition
                        fox_start?: DualPosition
                        duck?: DualPosition
                        pig?: DualPosition
                    };
                    launch?: ButtonElement
                    paytable_bg?: Sprite
                    launch_arrow?: Sprite
                    fox_fling?: SpineContainer
                    coop?: SpineContainer
                    faf_chicken_march?: SpineContainer
                    shadow?: Sprite
                    paytable_grand_value?: Text
                    paytable_mega_value?: Text
                    paytable_major_value?: Text
                    paytable_minor_value?: Text
                    paytable_mini_value?: Text
                    paytable_grand_label?: Text
                    paytable_mega_label?: Text
                    paytable_major_label?: Text
                    paytable_minor_label?: Text
                    paytable_mini_label?: Text
                };
            };
        };
    };
    public FlingBonusBackground: Layers & {
        scene: {
             bonus: Scene & {
                contents: {
                    tier_text?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    tier_text?: Text
                };
            };
        };
    };
    public ScreenFade: Layers & {
        scene: {
             black: Scene & {
                contents: {
                    fade?: SmartShape
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    fade?: SmartShape
                };
            };
        };
    };
    public BonusTransition: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    scatters_en?: Sprite
                    egg_pick_en?: Sprite
                    fowl_play_i18n?: Sprite
                    fowl_play_en?: Sprite
                    bonus_transition?: SpineContainer
                    scatters_i18n?: Text
                    egg_pick_i18n?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    scatters_en?: Sprite
                    egg_pick_en?: Sprite
                    fowl_play_i18n?: Sprite
                    fowl_play_en?: Sprite
                    bonus_transition?: SpineContainer
                    scatters_i18n?: Text
                    egg_pick_i18n?: Text
                };
            };
        };
    };
    public MenuButton: Layers & {
        scene: {
             base: Scene & {
                contents: {
                    ui_settings_menu_p?: ButtonElement
                    ui_settings_menu?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    ui_settings_menu_p?: ButtonElement
                    ui_settings_menu?: ButtonElement
                };
            };
        };
    };
    public Footer: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    value?: Text
                };
            };
        };
    };
    public BetBar: Layers & {
        scene: {
             bonus: Scene & {
                contents: {
                    top_bar?: SmartShape
                    bottom_bar?: SmartShape
                    gameId?: Text
                    time?: Text
                    total_win_value?: Text
                    balance_label?: Text
                    balance_value?: Text
                    slingo_stake?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    top_bar?: SmartShape
                    bottom_bar?: SmartShape
                    gameId?: Text
                    time?: Text
                    total_win_value?: Text
                    balance_label?: Text
                    balance_value?: Text
                    slingo_stake?: Text
                    ui_stake_menu_p?: ButtonElement
                    ui_stake_menu?: ButtonElement
                };
            };
             base: Scene & {
                contents: {
                    ui_stake_menu_p?: ButtonElement
                    top_bar?: SmartShape
                    bottom_bar?: SmartShape
                    ui_stake_menu?: ButtonElement
                    gameId?: Text
                    time?: Text
                    total_win_value?: Text
                    balance_label?: Text
                    balance_value?: Text
                    slingo_stake?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Collect: Layers & {
        scene: {
             collect: Scene & {
                contents: {
                    purchase?: ButtonElement
                    col_12?: Sprite
                    col_10?: Sprite
                    col_9?: Sprite
                    col_8?: Sprite
                    col_7?: Sprite
                    col_6?: Sprite
                    col_5?: Sprite
                    col_4?: Sprite
                    pot_12?: Sprite
                    pot_10?: Sprite
                    pot_9?: Sprite
                    pot_8?: Sprite
                    pot_7?: Sprite
                    pot_6?: Sprite
                    pot_5?: Sprite
                    pot_4?: Sprite
                    end_game?: ButtonElement
                    collect?: ButtonElement
                    potential_win_frame?: Sprite
                    shadow?: SmartShape
                    col_text?: Text
                    pot_text?: Text
                    you_could_win?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    purchase?: ButtonElement
                    col_12?: Sprite
                    col_10?: Sprite
                    col_9?: Sprite
                    col_8?: Sprite
                    col_7?: Sprite
                    col_6?: Sprite
                    col_5?: Sprite
                    col_4?: Sprite
                    pot_12?: Sprite
                    pot_10?: Sprite
                    pot_9?: Sprite
                    pot_8?: Sprite
                    pot_7?: Sprite
                    pot_6?: Sprite
                    pot_5?: Sprite
                    pot_4?: Sprite
                    end_game?: ButtonElement
                    collect?: ButtonElement
                    potential_win_frame?: Sprite
                    shadow?: SmartShape
                    col_text?: Text
                    pot_text?: Text
                    you_could_win?: Text
                };
            };
        };
    };
    public SpinCounter: Layers & {
        scene: {
             purchase: Scene & {
                contents: {
                    yellow_egg?: Sprite
                    straw?: Sprite
                    spins_remaining_value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    yellow_egg?: Sprite
                    straw?: Sprite
                    spins_remaining_value?: Text
                    brown_egg?: Sprite
                    white_egg?: Sprite
                };
            };
             free: Scene & {
                contents: {
                    brown_egg?: Sprite
                    straw?: Sprite
                    spins_remaining_value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             default: Scene & {
                contents: {
                    white_egg?: Sprite
                    straw?: Sprite
                    spins_remaining_value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Logo: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    logo_1_line?: Sprite
                    logo_3_lines?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    logo_1_line?: Sprite
                    logo_3_lines?: Sprite
                    logo_p?: Sprite
                    fp_logo?: Sprite
                };
            };
             slotbonus: Scene & {
                contents: {
                    logo_p?: Sprite
                    fp_logo?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public SpinButton: Layers & {
        scene: {
             base: Scene & {
                contents: {
                    spin?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    spin?: ButtonElement
                };
            };
             slotbonus: Scene & {
                contents: {
                    spin?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public CoinHopper: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    hopper_mask?: Sprite
                    free_spin_flying_coin?: SpineContainer
                    positions: {
                        [key: string]: DualPosition
                        hopper_top?: DualPosition
                        hopper_10?: DualPosition
                        hopper_9?: DualPosition
                        hopper_8?: DualPosition
                        hopper_7?: DualPosition
                        hopper_6?: DualPosition
                        hopper_5?: DualPosition
                        hopper_4?: DualPosition
                        hopper_3?: DualPosition
                        hopper_2?: DualPosition
                        hopper_1?: DualPosition
                        hopper_0?: DualPosition
                        hopper_bottom?: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        hopper_top?: DualPosition
                        hopper_10?: DualPosition
                        hopper_9?: DualPosition
                        hopper_8?: DualPosition
                        hopper_7?: DualPosition
                        hopper_6?: DualPosition
                        hopper_5?: DualPosition
                        hopper_4?: DualPosition
                        hopper_3?: DualPosition
                        hopper_2?: DualPosition
                        hopper_1?: DualPosition
                        hopper_0?: DualPosition
                        hopper_bottom?: DualPosition
                    };
                    hopper_mask?: Sprite
                    free_spin_flying_coin?: SpineContainer
                };
            };
        };
    };
    public SlingoLadder: Layers & {
        scene: {
             paytable: Scene & {
                contents: {
                    img_5?: Sprite
                    img_4?: Sprite
                    img_12?: Sprite
                    img_10?: Sprite
                    img_9?: Sprite
                    img_8?: Sprite
                    img_7?: Sprite
                    img_6?: Sprite
                    img_3?: Sprite
                    img_2?: Sprite
                    img_1?: Sprite
                    highlight_12?: Sprite
                    highlight_10?: Sprite
                    highlight_9?: Sprite
                    highlight_8?: Sprite
                    highlight_7?: Sprite
                    highlight_6?: Sprite
                    highlight_5?: Sprite
                    highlight_4?: Sprite
                    highlight_3?: Sprite
                    highlight_2?: Sprite
                    highlight_1?: Sprite
                    fill_12?: Sprite
                    fill_10?: Sprite
                    fill_9?: Sprite
                    fill_8?: Sprite
                    fill_7?: Sprite
                    fill_6?: Sprite
                    fill_5?: Sprite
                    fill_4?: Sprite
                    fill_3?: Sprite
                    fill_2?: Sprite
                    fill_1?: Sprite
                    bg?: Sprite
                    cover?: SmartShape
                    fake_stake_btn?: Sprite
                    text_12?: Text
                    text_10?: Text
                    text_9?: Text
                    text_8?: Text
                    text_7?: Text
                    text_5?: Text
                    text_4?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    img_5?: Sprite
                    img_4?: Sprite
                    img_12?: Sprite
                    img_10?: Sprite
                    img_9?: Sprite
                    img_8?: Sprite
                    img_7?: Sprite
                    img_6?: Sprite
                    img_3?: Sprite
                    img_2?: Sprite
                    img_1?: Sprite
                    highlight_12?: Sprite
                    highlight_10?: Sprite
                    highlight_9?: Sprite
                    highlight_8?: Sprite
                    highlight_7?: Sprite
                    highlight_6?: Sprite
                    highlight_5?: Sprite
                    highlight_4?: Sprite
                    highlight_3?: Sprite
                    highlight_2?: Sprite
                    highlight_1?: Sprite
                    fill_12?: Sprite
                    fill_10?: Sprite
                    fill_9?: Sprite
                    fill_8?: Sprite
                    fill_7?: Sprite
                    fill_6?: Sprite
                    fill_5?: Sprite
                    fill_4?: Sprite
                    fill_3?: Sprite
                    fill_2?: Sprite
                    fill_1?: Sprite
                    bg?: Sprite
                    cover?: SmartShape
                    fake_stake_btn?: Sprite
                    text_12?: Text
                    text_10?: Text
                    text_9?: Text
                    text_8?: Text
                    text_7?: Text
                    text_5?: Text
                    text_4?: Text
                    ladder_arrow?: Sprite
                    p_img_12?: Sprite
                    p_img_10?: Sprite
                    p_img_9?: Sprite
                    p_img_8?: Sprite
                    p_img_7?: Sprite
                    p_img_6?: Sprite
                    p_img_5?: Sprite
                    p_img_4?: Sprite
                    p_img_3?: Sprite
                    p_img_2?: Sprite
                    p_img_1?: Sprite
                    bars?: Sprite
                    p_highlight_12?: Sprite
                    p_highlight_10?: Sprite
                    p_highlight_9?: Sprite
                    p_highlight_8?: Sprite
                    p_highlight_7?: Sprite
                    p_highlight_6?: Sprite
                    p_highlight_5?: Sprite
                    p_highlight_4?: Sprite
                    p_highlight_3?: Sprite
                    p_highlight_2?: Sprite
                    p_highlight_1?: Sprite
                    p_fill_12?: Sprite
                    p_fill_10?: Sprite
                    p_fill_9?: Sprite
                    p_fill_8?: Sprite
                    p_fill_7?: Sprite
                    p_fill_6?: Sprite
                    p_fill_5?: Sprite
                    p_fill_4?: Sprite
                    p_fill_3?: Sprite
                    p_fill_2?: Sprite
                    p_fill_1?: Sprite
                    p_fill_0?: Sprite
                    ui_ladder?: ButtonElement
                };
            };
             base: Scene & {
                contents: {
                    ladder_arrow?: Sprite
                    p_img_12?: Sprite
                    p_img_10?: Sprite
                    p_img_9?: Sprite
                    p_img_8?: Sprite
                    p_img_7?: Sprite
                    p_img_6?: Sprite
                    p_img_5?: Sprite
                    p_img_4?: Sprite
                    p_img_3?: Sprite
                    p_img_2?: Sprite
                    p_img_1?: Sprite
                    bars?: Sprite
                    p_highlight_12?: Sprite
                    p_highlight_10?: Sprite
                    p_highlight_9?: Sprite
                    p_highlight_8?: Sprite
                    p_highlight_7?: Sprite
                    p_highlight_6?: Sprite
                    p_highlight_5?: Sprite
                    p_highlight_4?: Sprite
                    p_highlight_3?: Sprite
                    p_highlight_2?: Sprite
                    p_highlight_1?: Sprite
                    p_fill_12?: Sprite
                    p_fill_10?: Sprite
                    p_fill_9?: Sprite
                    p_fill_8?: Sprite
                    p_fill_7?: Sprite
                    p_fill_6?: Sprite
                    p_fill_5?: Sprite
                    p_fill_4?: Sprite
                    p_fill_3?: Sprite
                    p_fill_2?: Sprite
                    p_fill_1?: Sprite
                    p_fill_0?: Sprite
                    ui_ladder?: ButtonElement
                    img_1?: Sprite
                    img_2?: Sprite
                    img_3?: Sprite
                    img_4?: Sprite
                    img_5?: Sprite
                    img_6?: Sprite
                    img_7?: Sprite
                    img_8?: Sprite
                    img_9?: Sprite
                    img_10?: Sprite
                    img_12?: Sprite
                    highlight_12?: Sprite
                    highlight_10?: Sprite
                    highlight_9?: Sprite
                    highlight_8?: Sprite
                    highlight_7?: Sprite
                    highlight_6?: Sprite
                    highlight_5?: Sprite
                    highlight_4?: Sprite
                    highlight_3?: Sprite
                    highlight_2?: Sprite
                    highlight_1?: Sprite
                    fill_12?: Sprite
                    fill_10?: Sprite
                    fill_9?: Sprite
                    fill_8?: Sprite
                    fill_7?: Sprite
                    fill_6?: Sprite
                    fill_5?: Sprite
                    fill_4?: Sprite
                    fill_3?: Sprite
                    fill_2?: Sprite
                    fill_1?: Sprite
                    text_12?: Text
                    text_10?: Text
                    text_9?: Text
                    text_8?: Text
                    text_7?: Text
                    text_5?: Text
                    text_4?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public SymbolAnimations: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        chick_falls?: DualPosition
                    };
                };
            };
             slotbonus: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        chick_falls?: DualPosition
                    };
                };
            };
        };
    };
    public MatrixForeground: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    reel?: Sprite
                    grid?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    reel?: Sprite
                    grid?: Sprite
                };
            };
             slotbonus: Scene & {
                contents: {
                    grid?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public MatrixContent: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        FS?: DualPosition
                        P?: DualPosition
                        SJ?: DualPosition
                        J?: DualPosition
                        static?: DualPosition
                        symbol_0_0?: DualPosition
                        symbol_1_0?: DualPosition
                        symbol_2_0?: DualPosition
                        symbol_3_0?: DualPosition
                        symbol_4_0?: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        FS?: DualPosition
                        P?: DualPosition
                        SJ?: DualPosition
                        J?: DualPosition
                        static?: DualPosition
                        symbol_0_0?: DualPosition
                        symbol_1_0?: DualPosition
                        symbol_2_0?: DualPosition
                        symbol_3_0?: DualPosition
                        symbol_4_0?: DualPosition
                        win?: DualPosition
                        symbol_0_1?: DualPosition
                        symbol_0_2?: DualPosition
                        symbol_1_1?: DualPosition
                        symbol_1_2?: DualPosition
                        symbol_2_1?: DualPosition
                        symbol_2_2?: DualPosition
                        symbol_3_1?: DualPosition
                        symbol_3_2?: DualPosition
                        symbol_4_1?: DualPosition
                        symbol_4_2?: DualPosition
                    };
                };
            };
             slotbonus: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        win?: DualPosition
                        static?: DualPosition
                        symbol_0_0?: DualPosition
                        symbol_0_1?: DualPosition
                        symbol_0_2?: DualPosition
                        symbol_1_0?: DualPosition
                        symbol_1_1?: DualPosition
                        symbol_1_2?: DualPosition
                        symbol_2_0?: DualPosition
                        symbol_2_1?: DualPosition
                        symbol_2_2?: DualPosition
                        symbol_3_0?: DualPosition
                        symbol_3_1?: DualPosition
                        symbol_3_2?: DualPosition
                        symbol_4_0?: DualPosition
                        symbol_4_1?: DualPosition
                        symbol_4_2?: DualPosition
                    };
                };
            };
        };
    };
    public MatrixBackground: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    anticipation_highlight?: SmartShape
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    anticipation_highlight?: SmartShape
                    frame?: Sprite
                };
            };
             slotbonus: Scene & {
                contents: {
                    anticipation_highlight?: SmartShape
                    frame?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public TicketMatrix: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        dab?: DualPosition
                        symbol_0_0?: DualPosition
                        symbol_0_1?: DualPosition
                        symbol_0_2?: DualPosition
                        symbol_0_3?: DualPosition
                        symbol_0_4?: DualPosition
                        symbol_1_0?: DualPosition
                        symbol_1_1?: DualPosition
                        symbol_1_2?: DualPosition
                        symbol_1_3?: DualPosition
                        symbol_1_4?: DualPosition
                        symbol_2_0?: DualPosition
                        symbol_2_1?: DualPosition
                        symbol_2_2?: DualPosition
                        symbol_2_3?: DualPosition
                        symbol_2_4?: DualPosition
                        symbol_3_0?: DualPosition
                        symbol_3_1?: DualPosition
                        symbol_3_2?: DualPosition
                        symbol_3_3?: DualPosition
                        symbol_3_4?: DualPosition
                        symbol_4_0?: DualPosition
                        symbol_4_1?: DualPosition
                        symbol_4_2?: DualPosition
                        symbol_4_3?: DualPosition
                        symbol_4_4?: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        dab?: DualPosition
                        symbol_0_0?: DualPosition
                        symbol_0_1?: DualPosition
                        symbol_0_2?: DualPosition
                        symbol_0_3?: DualPosition
                        symbol_0_4?: DualPosition
                        symbol_1_0?: DualPosition
                        symbol_1_1?: DualPosition
                        symbol_1_2?: DualPosition
                        symbol_1_3?: DualPosition
                        symbol_1_4?: DualPosition
                        symbol_2_0?: DualPosition
                        symbol_2_1?: DualPosition
                        symbol_2_2?: DualPosition
                        symbol_2_3?: DualPosition
                        symbol_2_4?: DualPosition
                        symbol_3_0?: DualPosition
                        symbol_3_1?: DualPosition
                        symbol_3_2?: DualPosition
                        symbol_3_3?: DualPosition
                        symbol_3_4?: DualPosition
                        symbol_4_0?: DualPosition
                        symbol_4_1?: DualPosition
                        symbol_4_2?: DualPosition
                        symbol_4_3?: DualPosition
                        symbol_4_4?: DualPosition
                    };
                };
            };
        };
    };
    public TicketMatrixBacking: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    tile_12?: Sprite
                    tile_10?: Sprite
                    tile_9?: Sprite
                    tile_8?: Sprite
                    tile_7?: Sprite
                    tile_6?: Sprite
                    tile_5?: Sprite
                    tile_4?: Sprite
                    tile_3?: Sprite
                    tile_2?: Sprite
                    tile_1?: Sprite
                    frame_portrait?: Sprite
                    frame_landscape?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    tile_12?: Sprite
                    tile_10?: Sprite
                    tile_9?: Sprite
                    tile_8?: Sprite
                    tile_7?: Sprite
                    tile_6?: Sprite
                    tile_5?: Sprite
                    tile_4?: Sprite
                    tile_3?: Sprite
                    tile_2?: Sprite
                    tile_1?: Sprite
                    frame_portrait?: Sprite
                    frame_landscape?: Sprite
                };
            };
        };
    };
    public BackgroundIntermittentAnimation: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    orange_bird?: SpineContainer
                    rabbit?: SpineContainer
                    tractor?: SpineContainer
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    orange_bird?: SpineContainer
                    rabbit?: SpineContainer
                    tractor?: SpineContainer
                };
            };
             pick: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             fling: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public BackgroundPersistentAnimation: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    tree?: SpineContainer
                    tree_static?: Sprite
                    bg_orange_bird?: SpineContainer
                    birds?: SpineContainer
                    background_barn?: Sprite
                    windmill?: AnimatedSprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    tree?: SpineContainer
                    tree_static?: Sprite
                    bg_orange_bird?: SpineContainer
                    birds?: SpineContainer
                    background_barn?: Sprite
                    windmill?: AnimatedSprite
                };
            };
             fling: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Background: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    bg_portrait?: Sprite
                    bg_landscape?: Sprite
                    cover?: SmartShape
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    bg_portrait?: Sprite
                    bg_landscape?: Sprite
                    cover?: SmartShape
                };
            };
             onboard: Scene & {
                contents: {
                    bg_portrait?: Sprite
                    bg_landscape?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Onboard: Layers & {
        scene: {
             onboard: Scene & {
                contents: {
                    continue?: ButtonElement
                    load_bar_mask?: SmartShape
                    load_bar?: Sprite
                    bar_backing?: Sprite
                    onboard_text?: Text
                    legal_text?: Text
                    copyright_text?: Text
                    version_text?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    continue?: ButtonElement
                    load_bar_mask?: SmartShape
                    load_bar?: Sprite
                    bar_backing?: Sprite
                    onboard_text?: Text
                    legal_text?: Text
                    copyright_text?: Text
                    version_text?: Text
                };
            };
        };
    };
    public Prompts: Layers & {
        scene: {
             bonusmoney: Scene & {
                contents: {
                    cover?: SmartShape
                    ok?: ButtonElement
                    tc?: ButtonElement
                    frame?: Sprite
                    title?: Text
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    cover?: SmartShape
                    ok?: ButtonElement
                    tc?: ButtonElement
                    frame?: Sprite
                    title?: Text
                    body?: Text
                    total_win?: Text
                    total_win_label?: Text
                    win_breakdown?: Text
                    bonus?: Text | Sprite
                    arrow?: Sprite
                    scatter1?: Sprite
                    scatter2?: Sprite
                    scatter3?: Sprite
                    yes?: ButtonElement
                    no?: ButtonElement
                    continuenooptions?: ButtonElement
                    continue?: ButtonElement
                    history?: ButtonElement
                    logout?: ButtonElement
                };
            };
             gamesummary_nowin: Scene & {
                contents: {
                    cover?: SmartShape
                    frame?: Sprite
                    title?: Text | Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             gamesummary_win: Scene & {
                contents: {
                    cover?: SmartShape
                    frame?: SpineContainer
                    total_win?: Text
                    total_win_label?: Text
                    win_breakdown?: Text
                    title?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             scatterinfo: Scene & {
                contents: {
                    cover?: SmartShape
                    bonus?: Text | Sprite
                    arrow?: Sprite
                    scatter1?: Sprite
                    scatter2?: Sprite
                    scatter3?: Sprite
                    frame?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             yes_no: Scene & {
                contents: {
                    cover?: SmartShape
                    yes?: ButtonElement
                    no?: ButtonElement
                    frame?: Sprite
                    title?: Text
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             realitycheck: Scene & {
                contents: {
                    cover?: SmartShape
                    continuenooptions?: ButtonElement
                    continue?: ButtonElement
                    history?: ButtonElement
                    logout?: ButtonElement
                    frame?: Sprite
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             info: Scene & {
                contents: {
                    cover?: SmartShape
                    continue?: ButtonElement
                    frame?: Sprite
                    title?: Text
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Skip: Layers & {
        scene: {
             skip: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
}

export enum LayerNames {
    CelebrationContent = "celebrationcontent",
    CelebrationBackground = "celebrationbackground",
    Menus = "menus",
    SuperSpinWheel = "superspinwheel",
    FlingBonusTransition = "flingbonustransition",
    EggPickPaytable = "eggpickpaytable",
    BonusUI = "bonusui",
    EggPickBonus = "eggpickbonus",
    FlingBonusForeground = "flingbonusforeground",
    FlingBonus = "flingbonus",
    FlingBonusBackground = "flingbonusbackground",
    ScreenFade = "screenfade",
    BonusTransition = "bonustransition",
    MenuButton = "menubutton",
    Footer = "footer",
    BetBar = "betbar",
    Collect = "collect",
    SpinCounter = "spincounter",
    Logo = "logo",
    SpinButton = "spinbutton",
    CoinHopper = "coinhopper",
    SlingoLadder = "slingoladder",
    SymbolAnimations = "symbolanimations",
    MatrixForeground = "matrixforeground",
    MatrixContent = "matrixcontent",
    MatrixBackground = "matrixbackground",
    TicketMatrix = "ticketmatrix",
    TicketMatrixBacking = "ticketmatrixbacking",
    BackgroundIntermittentAnimation = "backgroundintermittentanimation",
    BackgroundPersistentAnimation = "backgroundpersistentanimation",
    Background = "background",
    Onboard = "onboard",
    Prompts = "prompts",
    Skip = "skip"
}

export const gameLayers = new GameLayers();
export const assetworksData = {gameLayers, LayerNames, SoundNames};
